import { FC } from "react";
import { StorageInvoicingComponent } from "~/components/admin/billing";
import PageMeta from "~/components/common/meta";

export const ScreenStorageInvoicing: FC = () => {
  return (
    <div>
      <PageMeta
        title="Storage Invoicing | Art Handler"
        description="Manage storage invoices for clients"
      />

      {/* Storage Invoicing Component */}
      <StorageInvoicingComponent />
    </div>
  );
};

export default ScreenStorageInvoicing;
